import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from '@material-ui/core';
import { ChangeEvent, FC } from 'react';
import { convertNumberToString } from 'containers/ExpertExpertise/FillExpertise/utils';
export interface CustomSelectProps {
  title: string;
  items: MenuItemProps[];
  value?: any;
  onChange?: (event: ChangeEvent<{ value: unknown }>) => void;
  disabled?: boolean;
  error?: any;
  errorMessage?: any;
}

interface MenuItemProps {
  label: string;
  value: any;
}

const CustomSelect: FC<CustomSelectProps> = ({
  title,
  items,
  onChange,
  value,
  disabled,
  errorMessage,
  error,
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel
        error={error}
        shrink={convertNumberToString(value) ? true : false}
      >
        {title}
      </InputLabel>
      <Select
        title={title}
        value={convertNumberToString(value) || null}
        onChange={onChange}
        disabled={disabled}
        error={error}
        displayEmpty
      >
        {items &&
          items.map(({ label, value }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
      </Select>
      {error && (
        <FormHelperText className="errorSelect">{errorMessage}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomSelect;
